"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var checkCondition_1 = __importDefault(require("./checkCondition"));
/**
 * Checks the provided patterns and throws an error if they don't meet certain conditions.
 * @param {ReplaceTagsOptions} options - The options object containing the patterns to check.
 * @returns {void}
 * @throws {Error} Throws an error if the patterns don't meet the conditions.
 */
var validatePatterns = function (_a) {
    var tagEndPattern = _a.tagEndPattern, tagStartPattern = _a.tagStartPattern, tagPattern = _a.tagPattern, onMissingPath = _a.onMissingPath;
    // Global Flag Checks
    (0, checkCondition_1.default)(!tagPattern.global, "tagPattern not flagged as global");
    (0, checkCondition_1.default)(tagStartPattern.global, "tagStartPattern flagged as global");
    (0, checkCondition_1.default)(tagEndPattern.global, "tagEndPattern flagged as global");
    // Start of string or line checks
    (0, checkCondition_1.default)(tagPattern.source.startsWith("^"), "tagPattern starts with `^`");
    (0, checkCondition_1.default)(!tagStartPattern.source.startsWith("^"), "tagStartPattern missing prefix `^`");
    (0, checkCondition_1.default)(tagEndPattern.source.startsWith("^"), "tagEndPattern starts with `^`");
    // End of string or line checks
    (0, checkCondition_1.default)(tagPattern.source.endsWith("$") &&
        !tagPattern.source.endsWith("\\$"), "tagPattern ends with unescaped `$`");
    (0, checkCondition_1.default)(tagStartPattern.source.endsWith("$") &&
        !tagStartPattern.source.endsWith("\\$"), "tagStartPattern ends with unescaped `$`");
    (0, checkCondition_1.default)(!tagEndPattern.source.endsWith("$"), "tagEndPattern missing suffix `$`");
    (0, checkCondition_1.default)(tagEndPattern.source.endsWith("\\$"), "tagEndPattern ends with escaped `$`");
    (0, checkCondition_1.default)(typeof onMissingPath !== "function", "onMissingPath is not a function");
};
exports.default = validatePatterns;
